import React from 'react';
import { useI18n } from '@/hooks/useI18n';

interface State { error: Error | null }

// 顶层兜底 — 任何 render-path throw(useStoreInfo provider 缺失 / useStoreId
// 缺 route param / ResourceShellView 兜底 throw / chart 字段非有限 …)都会
// 落到这里显示可重载错误页,不再让整窗白屏。class component 是 React 唯一
// 抓 render error 的接口;内部 ErrorFallback 用 useI18n 拿翻译(i18n 是
// module singleton,不依赖 Provider)。
export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // 至少留个堆栈给 dev console;prod 接 Sentry/Discord 是单独议题。
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info);
  }

  render() {
    if (this.state.error) return <ErrorFallback error={this.state.error} />;
    return this.props.children;
  }
}

const ErrorFallback: React.FC<{ error: Error }> = ({ error }) => {
  const { t } = useI18n();
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-xl p-6 shadow-sm">
        <p className="text-sm font-semibold text-slate-900">{t('common.error.load_failed')}</p>
        <p className="mt-2 text-xs text-slate-500 break-words font-mono">{error.message}</p>
        <button
          onClick={() => window.location.reload()}
          className="mt-4 px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium rounded-lg transition-colors cursor-pointer"
        >{t('common.action.retry')}</button>
      </div>
    </div>
  );
};
